import React from "react";
import {graphql, withApollo} from "react-apollo";
import {flowRight as compose} from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RecordWaterTestResultForPalletsForm";
import {cancelRecordWaterTestResultForPallets} from "../../../actions/InventoryApiActions";
import {showDatePicker} from "../../../actions/ViewActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class RecordWaterTestResultForPalletsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      pallets: null,
      loading: false,
      errors: []
    };
  }

  handleFind(values) {
    let productionDate = values.get("productionDate");

    this.setState({ loading: true, errors: [] });

    this.props.client.query({
      query: WATER_PALLETS_FOR_PRODUCTION_DATE,
      variables: { productionDate: productionDate },
      fetchPolicy: "network-only"
    })
    .then(({ data }) => {
      this.setState({ pallets: data.waterPalletsForProductionDate, loading: false, step: 2 });
    })
    .catch((err) => {
      this.setState({ loading: false, errors: createErrors(err) });
    });
  }

  handleBack() {
    this.setState({ step: 1 });
  }

  handleSubmit(values) {
    let pallets = this.state.pallets || [];

    if (pallets.length <= 0) {
      return;
    }

    let dataToSubmit = {
      palletIds: pallets.map(pallet => pallet.palletId),
      result: values.get("result"),
      labName: values.get("labName"),
      testNr: values.get("testNr")
    };

    return this.props.recordWaterTestResultForPallets(dataToSubmit)
      .then((response) => {
        if (response.data.recordWaterTestResultForPallets.errors.length <= 0) {
          this.props.cancelRecordWaterTestResultForPallets();
        } else {
          this.setState({ errors: createValidationErrors(response.data.recordWaterTestResultForPallets.errors) });
        }
      })
      .catch((err) => {
        this.setState({ errors: createErrors(err) });
      });
  }

  handleCancel() {
    this.props.cancelRecordWaterTestResultForPallets();
  }

  render() {
    return (
      <Form
        step={this.state.step}
        showDatePicker={this.props.showDatePicker}
        pallets={this.state.pallets}
        loading={this.state.loading}
        errors={this.state.errors}
        onFind={this.handleFind.bind(this)}
        onBack={this.handleBack.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    );
  }
}

const WATER_PALLETS_FOR_PRODUCTION_DATE = gql`
  query waterPalletsForProductionDate($productionDate: Date!) {
    waterPalletsForProductionDate(productionDate: $productionDate) {
      palletId
      skus
      state
      testResult
    }
  }
`;

const RECORD_WATER_TEST_RESULT_FOR_PALLETS = gql`
  mutation recordWaterTestResultForPallets($data: RecordWaterTestResultForPalletsInput!) {
    recordWaterTestResultForPallets(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  withApollo,
  graphql(RECORD_WATER_TEST_RESULT_FOR_PALLETS, {
    props: ({ mutate }) => ({
      recordWaterTestResultForPallets: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(
  null,
  { cancelRecordWaterTestResultForPallets, showDatePicker }
)(withQueries(RecordWaterTestResultForPalletsFormContainer));
